// Sturdfix WMS Constants

export const CATEGORY_COLORS = {
  bolt: '#1a56db',
  nut: '#7e3af2',
  washer: '#0891b2',
  stud: '#d97706',
  screw: '#059669',
  rod: '#dc2626',
  pin: '#374151',
  other: '#6b7280',
};

export const CATEGORY_LABELS = {
  bolt: 'Bolt',
  nut: 'Nut',
  washer: 'Washer',
  stud: 'Stud',
  screw: 'Screw',
  rod: 'Threaded Rod',
  pin: 'Pin / Rivet',
  other: 'Other',
};

export const ROW_COLORS = {
  A: '#1a2fce',
  B: '#0F6E56',
  C: '#534AB7',
  D: '#d97706',
};

// Dashboard stat card border colors
export const STAT_CARD_COLORS = {
  pallets_placed: '#1a2fce',
  slots_used: '#0F6E56',
  empty_slots: '#6b7280',
  pending_placement: '#d97706',
  qc_hold: '#e8191a',
  in_packing: '#534AB7',
};

// Activity badge colors
export const ACTIVITY_COLORS = {
  pallet_placed: '#22c55e',
  pallet_finalised: '#1a2fce',
  carton_added: '#7e3af2',
  packing_started: '#6b7280',
  issue: '#e8191a',
  issue_full: '#e8191a',
  issue_partial: '#e8191a',
  issue_box: '#e8191a',
  qc_hold_placed: '#d97706',
  cycle_count: '#0F6E56',
  location_move: '#0891b2',
  pallet_voided: '#374151',
};

export const STATUS_COLORS = {
  packing: '#d97706',
  ready: '#0891b2',
  placed: '#0e7a45',
  partial: '#b45309',
  issued: '#6b7280',
  void: '#e8191a',
  qc_hold: '#e8191a',
};

export const STATUS_LABELS = {
  packing: 'Packing',
  ready: 'Ready',
  placed: 'Placed',
  partial: 'Partial',
  issued: 'Issued',
  void: 'Void',
  qc_hold: 'QC Hold',
};

export const FINISH_OPTIONS = ['WZP', 'YZP', 'HDG', 'BZP', 'SELF', 'PLAIN', 'OTHER'];

export const BRAND_BLUE = '#1a2fce';
export const BRAND_RED = '#e8191a';
export const NAVY = '#0d1f6e';

export const AGE_COLORS = {
  empty: '#e5e7eb',
  fresh: '#22c55e',
  normal: '#84cc16',
  getting_old: '#f59e0b',
  slow: '#f97316',
  dead: '#ef4444',
  qc_hold: '#e8191a',
};

export const getAgeColor = (days) => {
  if (days <= 30) return AGE_COLORS.fresh;
  if (days <= 60) return AGE_COLORS.normal;
  if (days <= 90) return AGE_COLORS.getting_old;
  if (days <= 120) return AGE_COLORS.slow;
  return AGE_COLORS.dead;
};
